import DatabaseModel from './DatabaseModel.js';

var ConfigCombo = Object.create(DatabaseModel);

ConfigCombo.model = 'core/configcombo';
ConfigCombo.modelFront = 'configcombo';

export default ConfigCombo;
